import React from 'react'
import option from "../../assets/images/option.svg"
import {ButtonV1} from 'lib';
import "./index.scss"
import { Image } from 'lib';

const CustomTab  = (props) => {
  const {activeTab, setActiveTab,input_fields} = props

  return (
    <div className='tab_header'>
     <ul className='tab_header_list'>
        {input_fields.map(item => {
           return (
            <li onClick={() => setActiveTab(item.id)} className={`${activeTab ==item.id && "active"}`}>
              {item?.label}
            </li>
           )
        })}
    </ul>
    <div className='tab_header_buttons'>
      <ButtonV1 label="Reject" className="reject_button"/>
      <ButtonV1 label="Accept" className="accept_button"/>
      <Image imageSrc={option}/>
    </div>
    </div>
  )
}

export default CustomTab;